import { render, staticRenderFns } from "./SlotGameFilters.vue?vue&type=template&id=cb0150aa&"
import script from "./SlotGameFilters.vue?vue&type=script&lang=js&"
export * from "./SlotGameFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports